import { appConfig } from '@common/config';
import { ResultWrapFavorite } from '@components/ResultWrapFavorite';
import { Pagination } from '@components/pagination/Pagination';
import { type ISearchParam } from '@interface/ICommon';
import { type IDicItemList, type IDicParams } from '@interface/IItemDic';
import { ItemDictQueryKey } from '@network/queryKeys';
import { useDataQuery } from '@network/querys';
import { keepPreviousData } from '@tanstack/query-core';
import { type TFunction } from 'i18next';
import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { ItemList } from './ItemList';
import { ItemLisLineageClassic } from './ItemListLineageClassic';
import { useLocation } from 'react-router-dom';

export const ResultWrap = ({ params }: { params: IDicParams }) => {
    const { t } = useTranslation();
    const [dicParams, dicParamsSet] = useState<ISearchParam>({});
    const location = useLocation();

    const getSearchType = () => {
        const path = location.pathname;
        const match = path.match(/\/info\/(\w+)/);
        return match ? match[1] : 'item';  // 기본값으로 'item' 반환
    };

    useEffect(() => {
        const para: Record<string, string | number | null> = {
            size: 30,
            locale: 'zh-TW',
            grades: params.paramGrade,
            classes: params.paramClass,
            page: params.paramPage,
            category1: params.paramCategory1,
            category2: params.paramCategory2,
            searchKeyword: params.paramQuery,
            favorite: params.paramFavorite,
            exact: params.paramExactsearch,
            aligns: params.paramAlignment,
            elementals: params.paramElemental,
            forms: params.paramForm,
            region1: params.paramRegion1,
            region2: params.paramRegion2,
            region3: params.paramRegion3,
        };
        const filteredParams = Object.fromEntries(Object.entries(para).filter(([_, value]) => value !== undefined && value !== ''));
        dicParamsSet(filteredParams as ISearchParam);
    }, [params]);

    const searchType = getSearchType();

    const { data, isFetching, error } = useDataQuery<IDicItemList>(
        ItemDictQueryKey,
        `/${appConfig.service}/v2.0/dict/search/${searchType}`,  // 동적으로 경로 생성
        dicParams,
        {
            staleTime: 5000,
            placeholderData: keepPreviousData,
            enabled: !!dicParams?.size,
        }
    );

    return (
        <div className="gameinfo-result-wrapper">
            <div className="gameinfo-result">
                <section className="gameinfo-result__util">
                    <div className="title">
                        {t('noti.searchresults')}&nbsp;
                        {data && <CountOfSearchResults total={data.pagination.total} limit={data.pagination.limit} t={t} />}
                    </div>
                    <ResultWrapFavorite activeFavorite={params.paramFavorite} />
                </section>

                {appConfig.service === 'bns'
                    ? data && <ItemList listData={data.contents} priceListParam={dicParams} loading={isFetching} params={params} />
                    : data && <ItemLisLineageClassic listData={data.contents} priceListParam={dicParams} loading={isFetching} params={params} />
                }

                {!!error && (
                    <div className="nodata" style={{ display: 'block' }}>
                        <Trans i18nKey={'common.dataerror'} />
                    </div>
                )}

                {data?.contents && data.contents.length > 0 && <Pagination dat={data.pagination} />}
            </div>
        </div>
    );
};

const CountOfSearchResults = ({ total, limit, t }: { total: number; limit: number; t: TFunction<'translation', undefined> }) => (
    <em>
        <Trans>{t('noti.per').replace('{N}', `${total > limit ? limit + '+' : total}`)}</Trans>
    </em>
);
